



























import { Component, Prop, Vue } from "vue-property-decorator";
import { IExcursionCategory as ICategory } from "@/@types/excursions/excursions";

import ExcursionCatsHeader from "./excursion-cats-header.vue";
import StandartCategoryList from "@/components/app/dropdowns/standart-category-list.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    ExcursionCatsHeader,
    List: StandartCategoryList,
  },
})
export default class ExcursionCategorys extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;
  @Prop({ type: Boolean, default: false }) categoryDeleted!: boolean;

  search = "";

  get categoryList(): Array<ICategory> {
    return this.categorys.filter((item: ICategory) => {
      return (
        this.$getLocale(item.name)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) > -1
      );
    });
  }

  change(data: Partial<ICategory>, id: string): void {
    this.$emit("catChange", data, id);
  }
}
